export interface IAutoCompleteData {
  displayName: string;
  id: string;
}
export class AutoCompleteData implements IAutoCompleteData {
  constructor(
    public id: string,
    public displayName: string,
  ) {}
}
